import React from "react";
import Link from "@mui/material/Link";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ArrowForwardOutlined from "@mui/icons-material/ArrowForwardOutlined";
import { Link as RouterLink } from "react-router-dom";

/**
 * @param {object} props
 * @param {() => import("react").ReactNode} [props.Left]
 * @param {string} props.primary
 * @param {string} [props.secondary]
 * @param {import("react-router-dom").To} props.to
 */
export const ArrowListItem = ({ Left, primary, secondary, to }) => {
  return (
    <ListItem>
      {Left && <Left />}
      <ListItemText primary={primary} secondary={secondary} />
      <Link to={to} component={RouterLink}>
        <ListItemIcon>
          <ListItemButton>
            <ArrowForwardOutlined />
          </ListItemButton>
        </ListItemIcon>
      </Link>
    </ListItem>
  );
};
